import { api } from './apiClient';

export const fetchGiftCardList = async (page = 1, pageSize = 20, searchtext = '') => {
  try {
    const response = await api.post('/api/v1/admin/gift-cards/list', {
      pagination: { page, pageSize },
      searchtext: searchtext || '',
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || `Server error: ${error.response.status}`);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const createGiftCard = async (payload) => {
  try {
    const response = await api.post('/api/v1/admin/gift-cards', payload);
    return response.data;
  } catch (error) {
    if (error.response) {
      const errorData = error.response.data;
      if (Array.isArray(errorData?.errors)) {
        throw new Error(errorData.errors.join(', '));
      }
      throw new Error(errorData?.message || `Server error: ${error.response.status}`);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const updateGiftCard = async (payload) => {
  try {
    const response = await api.put('/api/v1/admin/gift-cards', payload);
    return response.data;
  } catch (error) {
    if (error.response) {
      const errorData = error.response.data;
      if (Array.isArray(errorData?.errors)) {
        throw new Error(errorData.errors.join(', '));
      }
      throw new Error(errorData?.message || `Server error: ${error.response.status}`);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const deleteGiftCard = async (id) => {
  try {
    const response = await api.delete(`/api/v1/admin/gift-cards/${id}`);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || `Server error: ${error.response.status}`);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};
